import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';
export var RequestLoadingIndicator = function (_a) {
    var loading = _a.loading;
    return (_jsx(Backdrop, { sx: { color: '#fff', zIndex: function (theme) { return theme.zIndex.modal + 100; } }, open: loading, children: _jsx(CircularProgress, { color: "inherit" }) }));
};
